import useFetchChartData from '@hooks/useFetchChartData'
import {
  FetchVenueAnalyticsGraphParams,
  VenueAnalyticsGraphRevenuePartySizeSpendingPattern,
} from '@models/venue/VenueAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { currencyFormat } from '@utils/currencyFormatter'
import { Segmented, theme } from 'antd'
import { useState } from 'react'
import { Bar, BarChart, LabelList, Tooltip, XAxis, YAxis } from 'recharts'
import { CenteredAxisTick } from '../common/AxisTicks'
import BaseChart from '../common/BaseChart'
import CustomTooltip from '../common/CustomTooltip'

const SpendPerPartySize = () => {
  const { token } = theme.useToken()
  const venue = useAppSelector(selectSelectedVenue())
  const [selectedSpend, setSelectedSpend] = useState<'reservation' | 'person'>(
    'reservation'
  )

  const { data, isLoading, error } = useFetchChartData<
    FetchVenueAnalyticsGraphParams,
    VenueAnalyticsGraphRevenuePartySizeSpendingPattern[]
  >({
    entity: 'venue',
    entityId: venue?.id,
    kind: 'revenue-party-size-spending-pattern',
    fetchFunction: fetchAnalyticsGraph,
    dependencies: [venue],
  })

  const dataKey =
    selectedSpend === 'reservation' ? 'spendPerReservation' : 'spendPerPerson'

  return (
    <BaseChart
      title="Party size spending patterns"
      data={data}
      isLoading={isLoading}
      error={error}
      actions={
        <Segmented
          value={selectedSpend}
          options={[
            { value: 'reservation', label: 'Per reservation' },
            { value: 'person', label: 'Per person' },
          ]}
          onChange={(e) => setSelectedSpend(e as 'reservation' | 'person')}
        />
      }
    >
      <BarChart data={data} margin={{ top: 30, right: 20, left: 0, bottom: 0 }}>
        <YAxis
          dataKey={dataKey}
          tickLine={false}
          stroke="#bbb"
          width={50}
          tickFormatter={(val) => currencyFormat(val, true, false, true)}
        />
        <XAxis
          dataKey="partySize"
          tickLine={false}
          stroke="#bbb"
          height={25}
          tick={(props) => <CenteredAxisTick {...props} />}
        />
        <Tooltip
          content={(props) => (
            <CustomTooltip
              type="bar"
              {...props}
              valueFormatter={(val) => currencyFormat(val, true, false)}
              customLabelFormatter={(payload) => {
                return `${payload.partySize} guests`
              }}
            />
          )}
        />
        <Bar dataKey={dataKey} fill={token.colorPrimary}>
          <LabelList
            dataKey={dataKey}
            fill="#fff"
            formatter={(value: any) => currencyFormat(value, true, false)}
            position="inside"
          />
        </Bar>
      </BarChart>
    </BaseChart>
  )
}

export default SpendPerPartySize
